// extracted by mini-css-extract-plugin
export default {"overlay":"Iw-z","bodyOpen":"Jw-z","content":"Kw-z","header":"Lw-z","close":"Mw-z","closeNoHeading":"Nw-z"};